import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MainColors } from '../../../../constants/Colors';
import FontSizes from '../../../../constants/FontSizes';
import Checkbox from '../../../../components/Checkbox';

const Priviledges = (props) => {
    return (
        <View style={styles.container}>
            <Text style={styles.label}>
                Priviledges
            </Text>
            <View style={styles.checkboxesContainer}>
                <Checkbox
                    onPress={props.onAdminPressed}
                    isChecked={props.isAdminChecked}
                    checkboxText='Admin'
                />
                <Checkbox
                    onPress={props.onMemberPressed}
                    isChecked={props.isMemberChecked}
                    checkboxText='Member'
                />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 30
    },
    label: {
        fontSize: FontSizes.medium,
        marginBottom: 8,
        marginLeft: 12,
        color: MainColors.mediumGray,
        fontWeight: '500'
    },
    checkboxesContainer: {
        marginLeft: 12
    },
    checkbox: {
        alignSelf: 'center',
        marginRight: 10
    }
});

export default Priviledges;